import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqData = [
    {
      question: "What are Moonbase Captains?",
      answer: "Moonbase Captains are NFTs that grant lifetime Premium Season Pass access to Moonbase Galaxies, our upcoming browser-based MMORTS. They also provide early access to Moonbase Alpha, our testing environment where we'll develop game mechanics throughout 2026."
    },
    {
      question: "How can I get a free Captain?",
      answer: "Free Captain Credits are awarded to eligible $MOONBASE holders (with at least 1 $MOONBASE on 11/8 and 11/19 snapshots, 906 total Captains), Derp NFT holders on Sonic (at least 2 on 11/19, around 250), and Hubble Protocol OGs and users (around 200). Check your eligibility in the minting app. One more $MOONBASE snapshot will be taken before mint for free credits. Limited to the top 600 holders with more than 2 $MOONBASE. 3 Free Credits maximum per wallet address."
    },
    {
      question: "What is the public mint?",
      answer: "3000 Captains available at 0.005 ETH. Public mint proceeds fund ecosystem development: 20% team, 40% Captains market making, and 40% $MOONBASE liquidity."
    },
    {
      question: "What network is this on?",
      answer: "Moonbase Captains are on the Base network. All game state for Moonbase Galaxies will be managed on Base Network."
    },
    {
      question: "What is Moonbase Galaxies?",
      answer: "Moonbase Galaxies is an in-browser MMORTS (Massively Multiplayer Online Real-Time Strategy) game focused on building colonies across pre-generated galaxies. The game features realistic population dynamics, colony management, and will be Free-To-Play with microtransactions. Captains get free Premium Season Pass for life."
    },
    {
      question: "What is Moonbase Alpha?",
      answer: "Moonbase Alpha is our testing environment where we'll develop and test game systems throughout 2026. It takes the form of an in-browser visual novel set in our Solar System in 2525, and will be exclusively available to $MOONBASE lockers and Moonbase Captains through at least 2026."
    }
  ];

  useEffect(() => {
    // Header scroll effect
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header && window.scrollY > 100) {
        header.style.background = 'rgba(10, 10, 20, 0.95)';
        header.style.backdropFilter = 'blur(10px)';
      } else if (header) {
        header.style.background = 'rgba(10, 10, 20, 0.8)';
        header.style.backdropFilter = 'blur(10px)';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      {/* Header */}
      <header>
        <div className="nav-container">
          <div className="logo">MC</div>
          <nav className="nav-links">
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a>
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>Features</a>
            <a href="#roadmap" onClick={(e) => { e.preventDefault(); scrollToSection('roadmap'); }}>Roadmap</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>FAQ</a>
          </nav>
          <a href="/mint" className="cta-button">MINT NOW</a>
        </div>
      </header>

      {/* Hero Section - Fullscreen with Background */}
      <section className="hero">
        <div className="hero-background">
          <img src="/hero-image.png" alt="Moonbase Captains Academy - Class of 2525" />
        </div>
        <div className="hero-content">
          <h1>MOONBASE CAPTAINS</h1>
          <p>Graduating Class of 2525</p>
          <div className="hero-buttons">
            <button className="hero-button primary">MINT YOUR CAPTAIN</button>
            <button className="hero-button secondary" onClick={() => scrollToSection('roadmap')}>EXPLORE THE VISION</button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about">
        <h2 className="section-title">THE MISSION</h2>
        <div className="about-container">
          <div className="about-content">
            <h3>LIFETIME PREMIUM ACCESS</h3>
            <p>Moonbase Captains grant owners lifetime Premium Season Pass access to Moonbase Galaxies - our upcoming browser-based MMORTS. Become a founding member of the interstellar empire-building experience and help shape the future of space colonization.</p>
            
            <h3>EXCLUSIVE EARLY ACCESS</h3>
            <p>Captains get exclusive access to Moonbase Alpha throughout 2026 - our testing environment where we'll develop shipbuilding, asteroid mining, colony management, and galactic conquest mechanics before the full game launch.</p>
            
            <h3>ECOSYSTEM FUNDING</h3>
            <p>Proceeds from the Moonbase Captains Public Mint fuel the development of our gaming ecosystem: 20% for development team, 40% for Captains market making, and 40% for $MOONBASE liquidity.</p>
          </div>
          <div className="about-image">
            <img src="/preview.gif" alt="Moonbase Captains Preview" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features">
        <h2 className="section-title">CAPTAIN BENEFITS</h2>
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">🎮</div>
            <h3>PREMIUM SEASON PASS</h3>
            <p>Lifetime free Premium Season Pass for Moonbase Galaxies - our upcoming MMORTS with colony building and galactic conquest.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>MOONBASE ALPHA ACCESS</h3>
            <p>Exclusive early access to our testing environment throughout 2026. Help develop game mechanics before public release.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💎</div>
            <h3>LUNARIUM EARNINGS</h3>
            <p>Earn Lunarium - our premium in-game currency - through staking and gameplay. Use it for fuel, credits, and empire expansion.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>FOUNDERS COMMUNITY</h3>
            <p>Join the exclusive Captains community in our private Discord. Help guide development and shape the future of Moonbase Galaxies.</p>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section id="roadmap">
        <h2 className="section-title">GALACTIC ROADMAP</h2>
        <div className="roadmap-container">
          <div className="roadmap-item">
            <div className="roadmap-phase">PHASE 1</div>
            <h3>CAPTAINS GRADUATION</h3>
            <ul>
              <li>Moonbase Captains NFT Mint</li>
              <li>Up to 3 Free Mints for Eligible addresses</li>
              <li>Public Mint @ 0.005 ETH</li>
              <li>Exclusive Discord Launch</li>
              <li>$MOONBASE Lunarium Mining Begins</li>
            </ul>
          </div>
          <div className="roadmap-item">
            <div className="roadmap-phase">PHASE 2</div>
            <h3>MOONBASE ALPHA</h3>
            <ul>
              <li>Moonbase Alpha Testing Environment Launch</li>
              <li>Exclusive to Captains & $MOONBASE Lockers</li>
              <li>Visual Novel Storyline in Our Solar System</li>
              <li>Shipbuilding & Asteroid Mining Tests</li>
              <li>Colony Management System Development</li>
            </ul>
          </div>
          <div className="roadmap-item">
            <div className="roadmap-phase">PHASE 3</div>
            <h3>SOLAR SYSTEM EXPANSION</h3>
            <ul>
              <li>Explore and Colonize Planets & Moons</li>
              <li>Base Invasion Mechanics Testing</li>
              <li>Advanced Colony Dynamics</li>
              <li>Population Management Systems</li>
              <li>Galaxy Preparation Phase</li>
            </ul>
          </div>
          <div className="roadmap-item">
            <div className="roadmap-phase">PHASE 4</div>
            <h3>MOONBASE GALAXIES LAUNCH</h3>
            <ul>
              <li>Full MMORTS Game Launch</li>
              <li>Multiple Simultaneous Galaxies</li>
              <li>Permanent & Seasonal Game Modes</li>
              <li>Free-to-Play with Microtransactions</li>
              <li>Captains: Free Premium Season Pass for Life</li>
            </ul>
          </div>
        </div>

        {/* Game Features Section */}
        <div className="badge-system">
          <h3 className="badge-title">MOONBASE GALAXIES FEATURES</h3>
          <div className="game-features">
            <div className="game-feature">
              <h4>🎯 MASSIVELY MULTIPLAYER STRATEGY</h4>
              <p>Build colonies across pre-generated galaxies in our browser-based MMORTS. Manage populations, resources, and compete for galactic dominance.</p>
            </div>
            <div className="game-feature">
              <h4>🌌 DYNAMIC GALAXY SYSTEM</h4>
              <p>Multiple simultaneous galaxies with different lifetimes (2 weeks to Permanent), fuel allowances, and unique map seeds. Each galaxy offers fresh challenges.</p>
            </div>
            <div className="game-feature">
              <h4>🏗️ COLONY MANAGEMENT</h4>
              <p>Realistic population dynamics and chaotic events make each colony unique. No simple farming - every empire requires strategic adaptation.</p>
            </div>
            <div className="game-feature">
              <h4>💰 DUAL CURRENCY ECONOMY</h4>
              <p>Credits for in-game purchases and Lunarium premium currency. Earn Lunarium through gameplay or purchase with USDC for accelerated progress.</p>
            </div>
          </div>
          <div className="badge-note">
            <p><strong>Moonbase Alpha:</strong> Exclusive testing environment for Captains and $MOONBASE lockers through 2026</p>
            <p><strong>Free Premium Access:</strong> Captains receive lifetime Premium Season Pass for Moonbase Galaxies</p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq">
        <h2 className="section-title">FREQUENTLY ASKED QUESTIONS</h2>
        <div className="faq-container">
          {faqData.map((faq, index) => (
            <div key={index} className={`faq-item ${activeFaq === index ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(index)}>
                {faq.question}
                <span className="faq-toggle">+</span>
              </div>
              <div className="faq-answer">
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-container">
          <div className="footer-col">
            <div className="footer-logo">MOONBASE CAPTAINS</div>
            <p className="footer-description">Graduating Class of 2525 - Founding members of Moonbase Galaxies MMORTS. Join us in building the future of space strategy gaming.</p>
            <div className="social-links">
              <a href="https://x.com/MoonbaseCaptain" className="social-link">X</a>
              <a href="https://discord.gg/FFwQegCaNc" className="social-link">DC</a>
            </div>
          </div>
          <div className="footer-col">
            <h3 className="footer-heading">QUICK LINKS</h3>
            <ul className="footer-links">
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>Mission</a></li>
              <li><a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>Benefits</a></li>
              <li><a href="#roadmap" onClick={(e) => { e.preventDefault(); scrollToSection('roadmap'); }}>Roadmap</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>FAQ</a></li>
            </ul>
          </div>
        </div>
        
        <div className="copyright">
          &copy; 2025 Moonbase Captains. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;